import { render, staticRenderFns } from "./IsInfo.vue?vue&type=template&id=3a3c76ab"
import script from "./IsInfo.vue?vue&type=script&lang=ts"
export * from "./IsInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports